import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { MutableRefObject, useCallback, useRef } from 'react';

export type OnGridReady = (event: GridReadyEvent) => void;
type Result = [
  MutableRefObject<GridApi | null>,
  MutableRefObject<ColumnApi | null>,
  OnGridReady,
];

export const useOnGridReady = (
  original?: OnGridReady,
  required?: OnGridReady,
): Result => {
  const api = useRef<GridApi | null>(null);
  const columnApi = useRef<ColumnApi | null>(null);
  const onGridReady = useCallback(
    (event: GridReadyEvent) => {
      original?.(event);
      api.current = event.api;
      columnApi.current = event.columnApi;
      required?.(event);
    },
    [original, required, api, columnApi],
  );

  return [api, columnApi, onGridReady];
};
